var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"application"},[_c('horizontal-table',{attrs:{"panes":_vm.navmenus,"activeName":_vm.$route.name},on:{"click":_vm.handleClick}}),_c('router-view',{staticClass:"application-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }